window.addEventListener('pageshow', () => {
    document.documentElement.classList.remove('page-leaving');
});

document.addEventListener('click', (e) => {
    if (document.documentElement.classList.contains('editmode')) {
        return;
    }

    const link = e.target.closest('a[href]');

    if (
        !link ||
        link.target === '_blank' ||
        link.hasAttribute('download') ||
        e.ctrlKey || e.metaKey || e.shiftKey ||
        link.href.startsWith('mailto:') ||
        link.href.startsWith('tel:') ||
        link.href.startsWith('#') ||
        link.origin !== window.location.origin ||
        link.pathname.startsWith('/mailto/')
    ) {
        return;
    }

    if (link.pathname === window.location.pathname && link.search === window.location.search && link.hash) {
        return;
    }

    e.preventDefault();
    document.documentElement.classList.add('page-leaving');

    setTimeout(() => {
        window.location.href = link.href;
    }, 150);
});
